import React from 'react';
import { PaymentConfigProvider as PCProvider } from '@lialo/payment/lib/config';
import { useServiceProvider } from '../common/Providers';
import config from '../config';
import { useDispatch } from 'react-redux';
import { appActions } from '@lialo/core/lib/pages/app';
import { useTranslation } from 'react-i18next';
import { Language } from '@lialo/common/lib/language';

interface IProps {
  children: React.ReactNode;
}

export const PaymentConfigProvider = ({ children }: IProps) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const serviceProvider = useServiceProvider();

  const onVersionError = React.useCallback(() => {
    dispatch(appActions.appUpdate.request());
  }, [dispatch]);

  const getIdToken = React.useCallback(async () => {
    const authService = await serviceProvider.getAuthService();
    const idToken = await authService.getIdToken();
    return idToken ?? null;
  }, [serviceProvider]);

  return (
    <PCProvider
      apiBaseUrl={config.apiUrl}
      apiContractVersion={config.apiContractVersion}
      onVersionError={onVersionError}
      getIdToken={getIdToken}
      language={i18n.language as Language}
    >
      {children}
    </PCProvider>
  );
};
